// 은행 거래내역 엑셀(국민은행 「거래내역조회」 다운로드 .xls 원본 그대로) → 입금 행 목록.
// 위쪽에 계좌·잔액 요약 몇 줄이 있고, 「거래일시」 가 든 줄이 헤더다(국민은행 2026-10 기준 7번째 줄).
// 칸은 제목으로 찾는다 — 순서가 바뀌어도 읽히게. 출금 행은 버린다.
import * as XLSX from 'xlsx';

const num = v => {
  if (typeof v === 'number') return v;
  const n = parseInt(String(v === undefined || v === null ? '' : v).replace(/[^0-9-]/g, ''), 10);
  return isNaN(n) ? 0 : n;
};

function pad(n) { return String(n).padStart(2, '0'); }

// 날짜 칸이 날짜형으로 들어온 경우까지 'YYYY.MM.DD HH:mm:ss' 로 맞춘다
function dateText(v) {
  if (v instanceof Date && !isNaN(v.getTime())) {
    return `${v.getFullYear()}.${pad(v.getMonth() + 1)}.${pad(v.getDate())} ${pad(v.getHours())}:${pad(v.getMinutes())}:${pad(v.getSeconds())}`;
  }
  return String(v === undefined || v === null ? '' : v).trim().replace(/[-/]/g, '.');
}

export function parseBankStatement(arrayBuffer) {
  const wb = XLSX.read(arrayBuffer, { type: 'array', cellDates: true });
  const sheet = wb.Sheets[wb.SheetNames[0]];
  const rows = XLSX.utils.sheet_to_json(sheet, { header: 1, raw: true, defval: '' });
  const h = rows.findIndex(r => Array.isArray(r) && r.some(c => String(c).trim() === '거래일시'));
  if (h < 0) throw new Error('「거래일시」 헤더를 찾지 못했습니다(국민은행 거래내역 원본 파일인지 확인)');
  const head = rows[h].map(c => String(c).replace(/\s/g, ''));
  const col = re => head.findIndex(c => re.test(c));
  const ci = {
    거래일시: col(/^거래일시$/),
    보낸분: col(/보낸분|의뢰인|받는분/),
    출금액: col(/출금액/),
    입금액: col(/입금액/),
    잔액: col(/잔액/)
  };
  if (ci.보낸분 < 0 || ci.입금액 < 0) throw new Error('「보낸분/받는분」·「입금액」 칸을 찾지 못했습니다');
  const out = [];
  let 출금행 = 0;
  for (const r of rows.slice(h + 1)) {
    if (!Array.isArray(r)) continue;
    const 거래일시 = dateText(r[ci.거래일시]);
    if (!/^\d{4}\.\d{2}\.\d{2}\s+\d{2}:\d{2}/.test(거래일시)) continue;
    const 입금액 = num(r[ci.입금액]);
    const 출금액 = ci.출금액 >= 0 ? num(r[ci.출금액]) : 0;
    if (!(입금액 > 0) || 출금액 > 0) { 출금행++; continue; }
    out.push({
      거래일시,
      보낸분: String(r[ci.보낸분] || '').trim(),
      입금액,
      잔액: ci.잔액 >= 0 ? num(r[ci.잔액]) : 0
    });
  }
  return { rows: out, 출금행 };
}
